import {skipWaiting as workbox_core_skipWaiting} from 'D:/FUENTES/LDCOM11/LD_EXPRESS/FUENTES/EXPRESS WEB/EXPRESS WEB/ClientApp/node_modules/workbox-core/skipWaiting.mjs';
import {clientsClaim as workbox_core_clientsClaim} from 'D:/FUENTES/LDCOM11/LD_EXPRESS/FUENTES/EXPRESS WEB/EXPRESS WEB/ClientApp/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from 'D:/FUENTES/LDCOM11/LD_EXPRESS/FUENTES/EXPRESS WEB/EXPRESS WEB/ClientApp/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








workbox_core_skipWaiting();

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "./ClientApp/public/dist/0.b1d684cf9a28b92729a1.js",
    "revision": "3601654a23149325572735e260a9c68a"
  },
  {
    "url": "./ClientApp/public/dist/16.d43bb85cd49ca54db6a6.js",
    "revision": "36bf1a69048b7ad2c7d049244b21a7d6"
  },
  {
    "url": "./ClientApp/public/dist/17.04c902cdf512793e0f97.js",
    "revision": "98a5f468f9ae0b7644370a30cb7383a3"
  },
  {
    "url": "./ClientApp/public/dist/18.cfeac3a7b14628168325.js",
    "revision": "bc2a702edef1218f876b0668703b6ac7"
  },
  {
    "url": "./ClientApp/public/dist/19.89b664ccc5cd994663f9.js",
    "revision": "af2807fe21848ee36a82475828e4daa2"
  },
  {
    "url": "./ClientApp/public/dist/2.86e6d250276fb688c9a4.js",
    "revision": "4bd2dbd174a7eb4a92f499fedbfea31c"
  },
  {
    "url": "./ClientApp/public/dist/20.85b90fc9efa2fa1678fc.js",
    "revision": "5245cdfa528feea39bdc54ecd36103dd"
  },
  {
    "url": "./ClientApp/public/dist/21.3f4ed33e68b1e3afe139.js",
    "revision": "ad9f8a36ec2bbef67dc24bfe0d313af0"
  },
  {
    "url": "./ClientApp/public/dist/22.3c388c2714f9ca340b5e.js",
    "revision": "e7ced3a7f4b2a8dde480a83dacec21ca"
  },
  {
    "url": "./ClientApp/public/dist/23.8ece06b0f51e316a643e.js",
    "revision": "8a0c8eee7cd45e6091c74408d1ba761c"
  },
  {
    "url": "./ClientApp/public/dist/24.9821e720b269bfeee028.js",
    "revision": "c64c5ab4d9348474b86b8c0813ba7989"
  },
  {
    "url": "./ClientApp/public/dist/25.df3e2efd05a9984900b3.js",
    "revision": "f7f49c1cc61dc69806bb0f9e876e2d41"
  },
  {
    "url": "./ClientApp/public/dist/26.89244955f286e6371881.js",
    "revision": "1f734405dc3a1fc52a47afa68bc7ddf6"
  },
  {
    "url": "./ClientApp/public/dist/27.c2085ff56fda7ca5d7a4.js",
    "revision": "cc789ee799b6d2e534d211d0314cd133"
  },
  {
    "url": "./ClientApp/public/dist/28.a36372305612b219b3e9.js",
    "revision": "3fed0b636c4615077857b3c1971f3b04"
  },
  {
    "url": "./ClientApp/public/dist/29.68880206eae67ad3d967.js",
    "revision": "85f4ee676c5e8720ba101e376f49fc35"
  },
  {
    "url": "./ClientApp/public/dist/3.0837a3e233e0b88e04a4.js",
    "revision": "d307acf549f7a24ba7912c2a4d1c2ed2"
  },
  {
    "url": "./ClientApp/public/dist/4.a1e3de77fd60aca1ceb7.js",
    "revision": "bdcc8e485069b375981b27b7b8e79af9"
  },
  {
    "url": "./ClientApp/public/dist/5.434b418a07ef0550d1b7.js",
    "revision": "0918d9ae08c08d86b4b5e7dcad589732"
  },
  {
    "url": "./ClientApp/public/dist/6.f22f9b903a86d21dd607.js",
    "revision": "74723e79376146f2588811789b9f3f45"
  },
  {
    "url": "./ClientApp/public/dist/runtimechunk~app.b9029333c9cde951690f.js",
    "revision": "c66ba89a649b3e8a38cafca4828d5374"
  }
], {});








